import React from 'react';
import styles from './slider.module.css';
import { rvDelay } from '../../utils/sectionReveal';
import { TSlider } from '../../utils/types';

const Slider: React.FC<TSlider> = ({translate, setActive, title, line, description, button, tabs}) => {
  const hoverHandlerEnter = () => {
    setActive(true);
  }
  const hoverHandlerExit = () => {
    //setActive(false);
  }

  let styleColor;
  switch (line) {
    case 'green':
      styleColor = styles.line_green;
      break
    case 'blue':
      styleColor = styles.line_blue;
      break
    case 'red':
      styleColor = styles.line_red;
      break
    case 'olive':
      styleColor = styles.line_olive;
      break
    case 'violet':
      styleColor = styles.line_violet;
      break
    default:
      styleColor = styles.line_green;
      break
  };

  return (
    <article
      className={styles.article}
      style={{translate: `${translate}%`}}
    >
      {tabs}
      <h2 className={`${styles.title} rv`} style={rvDelay(0.25)}>{title}</h2>
      <div className={`${styles.line} ${styleColor} rv rv-line rv-line-left`} style={rvDelay(0.4)}></div>
      <p className={`${styles.description} rv`} style={rvDelay(0.5)}>{description}</p>
      <div className={`${styles.buttonContainer} rv`} style={rvDelay(0.65)} onMouseEnter={hoverHandlerEnter} onMouseLeave={hoverHandlerExit}>
        {button}
      </div>
    </article>
  );
}

export default Slider;
